module.exports = __webpack_public_path__ + "static/img/16025A_1_V_20201120_LC.cba7eb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16025A_1_V_20201120_LC.png
// module id = c3t8
// module chunks = 0